function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
export function MailIcon(_0) {
    let { color = 'inherit' } = _0, props = _object_without_properties(_0, [
        "color"
    ]);
    var _props_width, _props_height;
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: (_props_width = props.width) !== null && _props_width !== void 0 ? _props_width : 20,
        height: (_props_height = props.height) !== null && _props_height !== void 0 ? _props_height : 20,
        viewBox: "0 0 24 24",
        fill: color,
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M18.7503 4.5H5.25028C4.48305 4.5 3.74724 4.79632 3.20472 5.32376C2.6622 5.85121 2.35742 6.56658 2.35742 7.3125V16.6875C2.35742 17.4334 2.6622 18.1488 3.20472 18.6762C3.74724 19.2037 4.48305 19.5 5.25028 19.5H18.7503C19.5175 19.5 20.2533 19.2037 20.7958 18.6762C21.3384 18.1488 21.6431 17.4334 21.6431 16.6875V7.3125C21.6431 6.56658 21.3384 5.85121 20.7958 5.32376C20.2533 4.79632 19.5175 4.5 18.7503 4.5ZM18.3549 6.375L12.6849 11.8875C12.5953 11.9754 12.4886 12.0451 12.3711 12.0927C12.2536 12.1403 12.1276 12.1648 12.0003 12.1648C11.873 12.1648 11.7469 12.1403 11.6294 12.0927C11.5119 12.0451 11.4053 11.9754 11.3156 11.8875L5.64564 6.375H18.3549ZM19.7146 16.6875C19.7146 16.9361 19.613 17.1746 19.4321 17.3504C19.2513 17.5262 19.006 17.625 18.7503 17.625H5.25028C4.99453 17.625 4.74926 17.5262 4.56843 17.3504C4.38759 17.1746 4.28599 16.9361 4.28599 16.6875V7.69687L9.95599 13.2094C10.4984 13.7361 11.2337 14.0319 12.0003 14.0319C12.7669 14.0319 13.5022 13.7361 14.0446 13.2094L19.7146 7.69687V16.6875Z"
        })
    }));
}
